<ng-container [formGroup]="macCellFormGroup">
    <mat-form-field fxFlex.sm="100" fxFlex.sx="100" fxFlex.gt-sm="50" *ngIf="item.$isInEditMode && item.category != 'module'">
        <mat-label>Module</mat-label>
        <mat-select [formControl]="macAddressFormControl" (selectionChange)="macChangeHandler($event)">
            <mat-option *ngFor="let macAddress of item.macAddresses" [value]="macAddress.id">
                {{ macAddress.description }}
            </mat-option>
        </mat-select>
    </mat-form-field>
</ng-container>

<span *ngIf="!item.$isInEditMode || item.category=='module'">
    {{ item.moduleDescription }}
</span>
